<template>
    <div class="card">
        <two-factor-auth-enable-modal
            :trans="trans"
            :actions="actions"
        >
        </two-factor-auth-enable-modal>

        <div class="card-header">
            <p class="card-header-title">
                {{ trans.title }}
            </p>
        </div>

        <div class="card-content field-label-container">
            <p class="title is-6 field">
                {{ trans.two_factor_auth }}
            </p>
            <div class="field">
                <i
                    class="fas fa-circle"
                    :class="`has-text-${twoFactorAuth.enabled ? 'success' : 'danger'}`"
                ></i>
                <span>
                    {{ trans[twoFactorAuth.enabled ? 'enabled' : 'disabled'] }}
                </span>
            </div>
            <div class="field">
                <button type="submit"
                        class="button is-info"
                        :class="{ 'is-loading': isLoading }"
                        :disabled="isLoading"
                        @click="twoFactorEnableClick"
                        v-if="!twoFactorAuth.enabled"
                >
                    {{ trans.enable }}
                </button>
                <button type="submit"
                        class="button is-info is-outlined"
                        :class="{ 'is-loading': isLoading }"
                        :disabled="isLoading"
                        @click="twoFactorDisableClick"
                        v-else
                >
                    {{ trans.disable }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin';
    import passwordVerifyMixin from "../mixins/passwordVerifyMixin";
    import {mapActions, mapState} from "vuex";

    export default {
        mixins: [
            axiosForm,
            passwordVerifyMixin,
        ],
        props: {
            actions: Object,
            two_factor_enabled: Boolean,
        },
        data() {
            return {
                okReport: 'Деактивация двухфакторной аутентификации',
                failReport: 'Ошибка деактивации двухфакторной аутентификации',
            };
        },
        computed: {
            ...mapState('twoFactorAuthEnableModal', [ 'twoFactorAuth' ]),
        },
        mounted() {
            if (this.two_factor_enabled) this.enableTwoFactor();
        },
        methods: {
            ...mapActions('twoFactorAuthEnableModal', {
                showTwoFactorModal: 'showModal',
                enableTwoFactor: 'enable',
                disableTwoFactor: 'disable',
            }),

            /**
             * Обработчик нажатия кнопки активации 2fa
             * @param e
             */
            twoFactorEnableClick(e) {
                if (!this.verifyPassword()) return;

                this.showTwoFactorModal();
            },

            /**
             * Обработчик нажатия кнопки деактивации 2fa
             * @param e
             */
            twoFactorDisableClick(e) {
                if (!this.verifyPassword()) return;

                this.submit(e, this.actions.disable);
            },

            /**
             * Обработчик ответа сервера
             */
            postResultHandler(response) {
                if (response.data.disabled) {
                    this.disableTwoFactor();
                }
            },

            /**
             * Обработчик успешного подтверждения пароля
             */
            onVerifiedPassword() {
                if (this.twoFactorAuth.enabled) {
                    this.twoFactorDisableClick();
                } else {
                    this.twoFactorEnableClick();
                }
            },
        }
    };
</script>
